function GuestContactReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestContactReport</div>
      </>
    );
  }
  
  export default GuestContactReport;